<template>
  <div class="welfare-detail pt-10">
    <div v-if="item">
      <!-- หัวข้อหลัก -->
      <!-- <h2 class="main-title mb-30">{{ item.title }}</h2> -->

      <!-- 1. ทุนเรียนดี -->
      <div class="section-block mb-30">
        <h3 class="section-title">1. ทุนเรียนดี (Academic Scholarship)</h3>
        <div class="performance-item-content">
          <div class="font-web mb-20" v-html="item.description" v-if="item.description"></div>

          <div class="content-section mb-10" v-if="item.content">
            <h4 class="font-web section-label">รายละเอียด / Description</h4>
            <div class="font-web mt-0 mb-0" style="white-space: pre-line" v-html="item.content"></div>

            <div class="mt-20">
              <img src="/images/hri_dashboard/walfare/Final_c_2.png"
                class="ml-20 img-fluid rounded shadow-sm previewable-img" alt="Academic Scholarship 2"
                style="width: 25%; cursor: pointer;"
                @click="handlePreview('/images/hri_dashboard/walfare/Final_c_2.png')" />
              <img src="/images/hri_dashboard/walfare/Final_c_1.png"
                class="ml-20 img-fluid rounded mb-10 shadow-sm previewable-img" alt="Academic Scholarship 1"
                style="width: 25%; cursor: pointer;"
                @click="handlePreview('/images/hri_dashboard/walfare/Final_c_1.png')" />
            </div>
          </div>

          <!-- <pre>{{ item.docs }}</pre> -->

          <div v-if="item.docs && item.docs.length > 0" class="mt-20">
            <table class="doc-table">
              <thead>
                <tr>
                  <th>รายการไฟล์ / File List</th>
                  <th class="text-center">Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(doc, idx) in item.docs" :key="idx">
                  <td>
                    <div class="file-name-main">{{ doc.thName }}</div>
                    <div v-if="doc.enName" class="file-name-sub">({{ doc.enName }})</div>
                    <div v-if="doc.updatedAt" class="file-date">อัปเดตเมื่อ: {{ formatDate(doc.updatedAt) }}</div>
                  </td>
                  <td class="text-center">
                    <a v-if="doc.thLink" :href="doc.thLink" target="_blank" class="download-link">
                      <a-icon type="download" />
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-15" v-if="item.link">
            <a-button type="primary" :href="item.link" target="_blank">
              อ่านรายละเอียดเพิ่มเติม
            </a-button>
          </div>
        </div>
      </div>

      <!-- ทุนเรียนฟรี -->
      <div class="section-block mb-30">
        <h3 class="section-title">2. ทุนเรียนฟรี (Free Education Scholarship)</h3>
        <div class="performance-item-content">
          <!-- <p class="text-muted italic mb-20">อยู่ระหว่างดำเนินการ / Content is being prepared</p> -->
          <img src="/images/hri_dashboard/walfare/Final_c_3.png" class="img-fluid rounded shadow-sm previewable-img"
            alt="Free Education Scholarship" style="width: 20%; cursor: pointer;"
            @click="handlePreview('/images/hri_dashboard/walfare/Final_c_3.png')" />

          <div v-if="getFreeEducationDocs().length > 0" class="mt-20">
            <table class="doc-table">
              <thead>
                <tr>
                  <th>รายการไฟล์ / File List</th>
                  <th class="text-center">Download</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(doc, idx) in getFreeEducationDocs()" :key="idx">
                  <td>
                    <div class="file-name-main">{{ doc.thName || doc.file_name }}</div>
                    <div v-if="doc.enName" class="file-name-sub">({{ doc.enName }})</div>
                    <div v-if="doc.updatedAt || doc.updated_at" class="file-date">อัปเดตเมื่อ: {{
                      formatDate(doc.updatedAt || doc.updated_at) }}</div>
                  </td>
                  <td class="text-center" style="width: 80px;">
                    <a v-if="doc.thLink || doc.doc_file" :href="doc.thLink || doc.doc_file" target="_blank"
                      class="download-link">
                      <a-icon type="download" />
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="text-muted mt-15 italic">ไม่มีเอกสาร (No documents found)</div>
        </div>
      </div>
    </div>
    <div v-else>
      <a-empty description="ไม่มีข้อมูล" />
    </div>

    <!-- Image Preview Modal -->
    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false" width="80%">
      <img alt="Preview" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      previewVisible: false,
      previewImage: ''
    };
  },
  methods: {
    getFreeEducationDocs() {
      if (!this.item || !this.item.docs) return [];
      const keywords = ['HR2026'];
      return this.item.docs.filter(doc => {
        const nameTh = doc.thName || doc.file_name || '';
        const nameEn = doc.enName || '';
        const nameOrig = doc.originalName || '';
        return keywords.some(kw => {
          const lowerKw = kw.toLowerCase();
          return nameTh.toLowerCase().includes(lowerKw) ||
            nameEn.toLowerCase().includes(lowerKw) ||
            nameOrig.toLowerCase().includes(lowerKw);
        });
      });
    },
    formatDate(date) {
      if (!date) return '-';
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    handlePreview(imageSrc) {
      this.previewImage = imageSrc;
      this.previewVisible = true;
    }
  }
};
</script>

<style scoped>
.section-block {
  background: #fff;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.section-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 8px;
}

.performance-item-title {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #1a1a2e !important;
  margin-bottom: 12px;
}

.performance-item-content {
  color: #595959;
  font-size: 14px;
  line-height: 1.6;
}

.section-label {
  font-size: 13px;
  font-weight: 700;
  color: #8c8c8c;
  text-transform: uppercase;
  margin-bottom: 5px;
  letter-spacing: 0.5px;
}

.doc-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.doc-table th {
  background: #f8f9fa;
  padding: 12px 15px;
  text-align: left;
  font-weight: 700;
  color: #1a1a2e;
  border-bottom: 2px solid #e8e8e8;
  font-size: 14px;
}

.doc-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #f0f0f0;
  color: #434343;
  font-size: 14px;
}

.file-name-main {
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.4;
}

.file-name-sub {
  font-size: 12px;
  color: #8c8c8c;
  margin-top: 2px;
  font-style: italic;
}

.file-date {
  font-size: 11px;
  color: #bfbfbf;
  margin-top: 4px;
}

.text-center {
  text-align: center;
}

.download-link {
  color: #4285F4;
  font-size: 18px;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.download-link:hover {
  color: #1a73e8;
  transform: translateY(-2px);
}

.text-muted {
  color: #8c8c8c;
}

.italic {
  font-style: italic;
}

.mt-15 {
  margin-top: 15px;
}

.mt-20 {
  margin-top: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-30 {
  margin-bottom: 30px;
}

.pt-10 {
  padding-top: 10px;
}
</style>
